// extracted by mini-css-extract-plugin
export default {"checkboxRoot":"manualpo__SearchEntry-module__checkboxRoot___mTGEh","checkboxLabel":"manualpo__SearchEntry-module__checkboxLabel___FIos4"};